<template>
  <a-modal
    ref="createModal"
    title="工单新增"
    :width="850"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="20">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="加工组织" prop="desOrganizationCode">
            <global-select
              :value.sync="form.desOrganizationCode"
              selectType="selectFilter"
              requestApi="/system/user/inventOrgAll"
              :selectItem="{ value: 'realValue', label: 'label' }"
              @change="getClassCodeBox"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划单号" prop="orderNo">
            <a-input v-model="form.orderNo" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="工单分类" prop="classCode">
            <a-select show-search option-filter-prop="children" :dropdown-match-select-width="false" v-model="form.classCode" allowClear @change="classCodeOnChange">
              <a-select-option v-for="(item) in classCodeList" :key="item.realValue">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="工单类型" prop="jobType">
            <a-select v-model="form.jobType" allowClear>
              <a-select-option v-for="(item) in jobTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="成品编码" prop="assembly">
            <global-select
              :value.sync="form.assembly"
              selectType="selectAssembleSearch"
              :focusGet="true"
              requestApi="/mes/mesDiscreteJobs/assemblyBoxNoOrg"
              :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
              searchParam="itemCode"
              :setParams="{ organizationCode: form.desOrganizationCode }"
              :dropdown-match-select-width="false"
              @change="globalSelectChange" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="规格描述" prop="description">
            <a-input v-model="form.description" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="车间" prop="workCode">
            <global-select
              :value.sync="form.workCode"
              selectType="select"
              requestApi="/mes/mesDiscreteJobs/workCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ organizationCode: form.desOrganizationCode }"
              @change="workCodeChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="产线" prop="lineId">
            <global-select
              :value.sync="form.lineId"
              selectType="select"
              requestApi="/mes/mesDiscreteJobs/lineCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ workCode: form.workCode }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划数量" prop="planQuantity">
            <a-input-number v-model="form.planQuantity" :min="0" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划开始时间" prop="scheduledStartDate">
            <a-date-picker
              v-model="form.scheduledStartDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划完成时间" prop="scheduledCompletionDate">
            <a-date-picker
              v-model="form.scheduledCompletionDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="交货时间" prop="deliveryDate">
            <a-date-picker
              v-model="form.deliveryDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="备注" prop="remarks">
            <a-input v-model="form.remarks" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="MRP净值" prop="mrpFlag">
            <a-switch :checked="form.mrpFlag === 'Y'" @change="switchOnChange(form)" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import moment from 'moment';
import {
  apiMesDiscreteJobsClassCodeToType,
  apiMesDiscreteJobsAdd,
  apiMesDiscreteJobsClassCodeBox
} from '@/api/mes/workOrderManage/workOrderDesk'
// 表单字段
export default {
  props: {},
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      // readOnly: false,
      visible: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 16 }
      },
      // 表单参数
      form: {
        desOrganizationCode: undefined,
        organizationCode: undefined,
        classCode: undefined,
        jobType: undefined,
        assembly: undefined,
        description: undefined,
        workCode: undefined,
        lineId: undefined,
        planQuantity: undefined,
        orderNo: undefined,
        scheduledStartDate: undefined,
        scheduledCompletionDate: undefined,
        deliveryDate: undefined,
        remarks: undefined,
        mrpFlag: 'N'
      },
      // 表单校验
      rules: {
        desOrganizationCode: [
          { required: true, message: '请选择加工组织', trigger: 'change' }
        ],
        organizationCode: [
          { required: true, message: '请选择需求组织', trigger: 'change' }
        ],
        classCode: [
          { required: true, message: '请选择工单分类', trigger: 'change' }
        ],
        jobType: [
          { required: true, message: '请选择工单类型', trigger: 'change' }
        ],
        assembly: [
          { required: true, message: '请选择成品编码', trigger: 'change' }
        ],
        workCode: [
          { required: true, message: '请选择车间', trigger: 'change' }
        ],
        lineId: [
          { required: true, message: '请选择产线', trigger: 'change' }
        ],
        planQuantity: [
          { required: true, message: '计划数量不能为空', trigger: 'blur' }
        ],
        scheduledStartDate: [
          { required: true, message: '请选择计划开始时间', trigger: 'change' }
        ],
        scheduledCompletionDate: [
          { required: true, message: '请选择计划完成时间', trigger: 'change' }
        ],
        deliveryDate: [
          { required: true, message: '请选择交货时间', trigger: 'change' }
        ],
        remarks: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ]
      },
      jobTypeList: [],
      classCodeList: []
    }
  },
  created () {
    this.getLookupList('MES_JOB_TYPE', 'jobTypeList')
    this.getClassCodeBox()
  },
  methods: {
    // 成品编码
    globalSelectChange (val, list) {
      const seletItem = list.find(item => {
        return item.selectedValue === val
      })
      this.form.assemblyItemId = seletItem.realValue
      this.form.description = seletItem.bringOutDataOne
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    moment,
    switchOnChange (form) {
      form.mrpFlag = form.mrpFlag === "Y" ? "N" : "Y"
    },
    // 工单分类
    classCodeOnChange (val) {
      apiMesDiscreteJobsClassCodeToType({ classCode: val }).then(res => {
        if (res.code === 200 && res.data) {
          this.form.jobType = res.data.realValue
        }
      })
    },
    show () {
      this.visible = true
      this.confirmLoading = false
    },
    // 关闭模态框
    close () {
      this.$refs.ruleForm.resetFields();
      this.visible = false
      this.reset()
    },
    // 保存
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.form.scheduledStartDate = this.$moment(this.form.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.form.scheduledCompletionDate = this.$moment(this.form.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss')
          this.form.deliveryDate = this.$moment(this.form.deliveryDate).format('YYYY-MM-DD HH:mm:ss')
          this.confirmLoading = true
          apiMesDiscreteJobsAdd(this.form).then(response => {
            if (response.code === 200) {
              this.$message.success('新增成功')
              // 关闭本组件
              this.visible = false
              // 调用外部刷新列表方法
              this.$emit('handle-success')
              // 刷新表单
              this.reset()
              this.confirmLoading = false
            } else {
              this.$message.error(response.msg)
              this.confirmLoading = false
            }
          }).catch(() => {
            this.confirmLoading = false
          })
        } else {
          return (this.confirmLoading = false)
        }
      })
    },
    // 表单重置
    reset () {
      this.form = {
        desOrganizationCode: undefined,
        organizationCode: undefined,
        classCode: undefined,
        jobType: undefined,
        assembly: undefined,
        description: undefined,
        workCode: undefined,
        lineId: undefined,
        planQuantity: undefined,
        orderNo: undefined,
        scheduledStartDate: undefined,
        scheduledCompletionDate: undefined,
        deliveryDate: undefined,
        remarks: undefined,
        mrpFlag: 'N'
      }
    },
    // 加工组织
    getClassCodeBox () {
      this.form.classCode = undefined
      this.form.assembly = undefined
      this.form.description = undefined
      this.form.workCode = undefined
      this.form.lineId = undefined
      apiMesDiscreteJobsClassCodeBox({ organizationCode: this.form.desOrganizationCode }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.classCodeList = res.data;
        }
      })
    },
    // 车间
    workCodeChange () {
      this.form.lineId = undefined
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
/deep/.ant-select{
  width: 180px;
}
input{
  width: 180px;
}
/deep/.ant-input-number{
  width: 180px;
}
/deep/.ant-calendar-picker{
  min-width: 180px !important;
}
/deep/.ant-form-item-control{
  min-width: 180px !important;
}
</style>
